/**
 * Inicia o download de um arquivo a partir de um Blob.
 * @param {Blob} fileBlob O conteúdo do arquivo como um Blob.
 * @param {string} fileName O nome do arquivo para o download.
 */
export async function downloadFile (fileBlob, fileName) {
  if (!fileBlob || !fileName) {
    console.error('Arquivo ou nome do arquivo não disponível para download.')
    return
  }

  try {
    if (fileBlob.size === 0) {
      throw new Error('Arquivo vazio ou não encontrado')
    }

    const fileExtension = fileName.split('.').pop().toLowerCase()
    let mimeType = fileBlob.type

    // Mapeamento de extensões para MIME types
    const mimeTypes = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }

    if (!mimeType || mimeType === 'application/octet-stream') {
      mimeType = mimeTypes[fileExtension] || 'application/octet-stream'
    }

    const finalFile = mimeType !== fileBlob.type ? new Blob([fileBlob], { type: mimeType }) : fileBlob
    const url = URL.createObjectURL(finalFile)

    const link = document.createElement('a')
    link.download = fileName
    link.href = url
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()

    // Limpeza
    setTimeout(() => {
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }, 100)
  } catch (error) {
    console.error('Erro ao fazer download do arquivo:', error)
    // O ideal é usar um sistema de notificação global aqui
    alert('Erro ao fazer download do arquivo: ' + error.message)
  }
}
